import { supabase } from './supabase'

export interface VoidAuditPayload {
  restaurant_id: number
  table_id?: number | null
  order_id?: number | null
  order_item_id?: number | null
  action_type: 'cancel_order' | 'remove_item' | 'void_payment'
  authorized_by: string
  reason: string
  original_amount: number
  item_name?: string | null
}

export async function logVoidAudit(payload: VoidAuditPayload) {
  const dbPayload = {
    restaurant_id: payload.restaurant_id,
    table_id: payload.table_id,
    order_id: payload.order_id,
    item_id: payload.order_item_id,
    action_type: payload.action_type,
    authorized_name: payload.authorized_by,
    reason: payload.reason,
    amount: payload.original_amount,
    detail: payload.item_name,
  }

  const { error } = await supabase.from('void_audit_log').insert([dbPayload])

  if (error) {
    console.error('Error logging void audit:', error)
    throw new Error('Failed to log void audit')
  }
}

export async function updateVoidedColumns(
  table: 'orders' | 'order_items',
  id: number,
  authorizedBy: string,
  reason: string,
) {
  const { error } = await supabase
    .from(table)
    .update({
      voided_at: new Date().toISOString(),
      voided_by: authorizedBy,
      void_reason: reason,
      status: 'cancelled',
    })
    .eq('id', id)

  if (error) {
    console.error(`Error updating voided columns on ${table}:`, error)
    throw new Error(`Failed to update voided columns on ${table}`)
  }
}
